/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventGroupInfo,
    JsonEventGroupInfoFromJSON,
    JsonEventGroupInfoFromJSONTyped,
    JsonEventGroupInfoToJSON,
} from './JsonEventGroupInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventGroupInfo
 */
export interface ApiResultOfListOfJsonEventGroupInfo {
    /**
     * 
     * @type {Array<JsonEventGroupInfo>}
     * @memberof ApiResultOfListOfJsonEventGroupInfo
     */
    data?: Array<JsonEventGroupInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventGroupInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventGroupInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventGroupInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventGroupInfo
     */
    result?: ApiResultOfListOfJsonEventGroupInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventGroupInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventGroupInfoFromJSON(json: any): ApiResultOfListOfJsonEventGroupInfo {
    return ApiResultOfListOfJsonEventGroupInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventGroupInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventGroupInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventGroupInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventGroupInfoToJSON(value?: ApiResultOfListOfJsonEventGroupInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventGroupInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

